
















import { Component, Prop, Vue } from 'vue-property-decorator'
import VideoViewer from '@/components/VideoViewer.vue'
import Overlay from '@/components/Overlay.vue'

@Component({
  components: {
    VideoViewer,
    Overlay
  }
})
export default class App extends Vue {
  private show = false;
}
